export interface PredictionModel {
  id: string;
  name: string;
  description: string;
  accuracy: number;
  lastTrained: string;
  status: 'active' | 'inactive' | 'training' | 'error';
  metrics: string[];
}

export const examplePredictionModels: PredictionModel[] = [
  {
    id: '1',
    name: 'Glucose Prediction Model',
    description: 'Predicts blood glucose levels based on diet, exercise, and medication',
    accuracy: 87.3,
    lastTrained: '2025-01-20T15:30:00Z',
    status: 'active',
    metrics: ['Blood Glucose', 'Diet', 'Exercise', 'Medication']
  },
  {
    id: '2',
    name: 'Blood Pressure Model',
    description: 'Forecasts blood pressure trends using lifestyle and medication data',
    accuracy: 92.1,
    lastTrained: '2025-01-18T12:15:00Z',
    status: 'active',
    metrics: ['Blood Pressure', 'Stress', 'Diet', 'Medication']
  },
  {
    id: '3',
    name: 'Weight Management Model',
    description: 'Predicts weight changes based on caloric intake and activity',
    accuracy: 78.9,
    lastTrained: '2025-01-22T09:45:00Z',
    status: 'active',
    metrics: ['Weight', 'Calories', 'Exercise', 'Sleep']
  }
]; 